
"use strict";

var React = require('react');
var Link = require('react-router').Link;
var classNames = require('classnames');

class ProgramFilterNavigation extends React.Component {
	render() {

		var { filters, ...other} = this.props;
		if(!filters || filters.isEmpty()) {
			return false;
		}

		return (
			<ul {...other} className="svtse_program-list-filters__list">
				{filters.toArray().map( function(item, index){

					var query = this.context.location.query? Object.assign({}, this.context.location.query) : {};
					query.filter = item.get('toggleQuery', undefined);
					if(!query.filter) {
						delete query.filter;
					}
					var listClass = classNames({
						'svtse_program-list-filters__item': true,
						'svtse_program-list-filters__item--active' : item.get('isActive', false)
					});

					var linkClass = classNames({
						'svtse_program-list-filters__link': true,
						'svtse_program-list-filters__link--active' : item.get('isActive', false)
					});

					return (
						<li  className={listClass} key={item.get('id', index)}>
							<Link to="/program/" className={linkClass} query={query}>{item.get('title')}</Link>
						</li>
					);
				}.bind(this))}
			</ul>
		);
	}
}

ProgramFilterNavigation.contextTypes = {
		location: React.PropTypes.object.isRequired
};

module.exports = ProgramFilterNavigation;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramFilterNavigation.jsx
 **/